import {GlobalVariables} from "../GlobalVariables";
export default class BlockAnchor {
	static init() {

		const hash = window.location.hash.substring(1);
		this.scrollToHash(hash);

	}

	static scrollToHash(hash) {
		if (hash) {
			const target = document.querySelector(`#${hash}`);
			if (target) {

				if (GlobalVariables.lenis !== null) {
					setTimeout(() => {
						GlobalVariables.lenis.scrollTo(target, true);
					}, 500);
				} else {
					setTimeout(() => {
						target.scrollIntoView({
							behavior: "smooth",
							block: "start",
						});
					}, 500);
				}

			}
		}
	}

}
